/**
 * Core starts its error messages with the name of the function that threw
 * ("buildObjects: …", "rows.update: …"), and a wrapped error repeats that
 * inside the message. Those names help a log reader or an MCP agent, not a
 * user reading a toast ("Failed to create time: buildObjects: …").
 *
 * Leading names are any lowercase identifier ("update: "). Inner ones, after
 * ": ", must be camelCase or dotted ("applyRelationOps: ", "rows.update: "), so
 * plain words in a message stay.
 */
const LEADING_NAMES = /^(?:[a-z]\w*(?:\.[a-z]\w*)*: )+/
const INNER_NAMES = /: (?:[a-z]\w*(?:[A-Z]\w*|\.[a-z]\w*)+: )+/g

/**
 * An error's message as a toast should show it: core's function-name prefixes
 * stripped. The error itself is not changed, so log the error object when the
 * full text matters. Every toast that shows an error message goes through
 * this (eslint.config.js enforces it).
 */
export function errorMessage(err: unknown): string {
  if (err == null) return ""
  const message =
    typeof err === "string"
      ? err
      : typeof (err as { message?: unknown }).message === "string"
        ? (err as { message: string }).message
        : String(err)
  return message.replace(LEADING_NAMES, "").replace(INNER_NAMES, ": ")
}
